export const SessionDataMap = {
  'cacheData.data.AriesReservation.defaultTab': 'defaultTab',
  'cacheData.data.AriesReservation.propertyId': 'propertyId',
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.checkInDate': 'checkInDate',
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.clusterCode': 'clusterCode',
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.rewardsRedemption': 'rewardsRedemption',
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.corporateCode': 'corporateCode',
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.groupCode': 'groupCode',
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.groupCodes': 'groupCodeList',
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.checkOutDate': 'checkOutDate',
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.childrenAges': 'childrenAges',
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.numAdultsPerRoom': 'numAdultsPerRoom',
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.numGuestsPerRoom': 'numGuestsPerRoom',
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.numChildrenPerRoom': 'numChildrenPerRoom',
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.numRooms': 'numRooms',
  'cacheData.data.travelAgentType': 'travelAgentType',
  'cacheData.data.AriesReservation.crsSystem': 'crsSystem',
  authenticated: 'isAuth',
  locale: 'locale',
  'cacheData.data.AriesReservation.ersProperty': 'isErs',
  'cacheData.data.AriesReservation.confirmationNumber': 'confirmationNumber',
  'cacheData.data.AriesReservation.tripsXRequestedByHeader': 'tripsXRequestedByHeader',
  'cacheData.data.AriesSearch.searchCriteria.selectedCurrency': 'searchSelectedCurrency',
  'cacheData.data.AriesReservation.selectedCurrency': 'resSelectedCurrency',
  'cacheData.data.AriesReservation.propertyCurrency': 'propertyCurrency',
  'cacheData.data.AriesCommon.memState': 'userState',
  'cacheData.data.consumerID': 'consumerID',
  'cacheData.data.AriesSearch.searchCriteria.availabilityRequestVO.lengthOfStay': 'lengthOfStay',
  'cacheData.data.AriesCommon.page_url_query_string': 'page_url_query_string',
};

export const APIDataMap = {
  'memberOnlyRate.edges': 'memberOnlyData',
  'regularRate.edges': 'regularData',
  'searchProductsByProperty.errors': 'nonErsError',
  'memberOnlyRate.total': 'memberOnlyTotal',
  'regularRate.total': 'regularRateTotal',
  'memberOnlyRate.errors': 'memberOnlyError',
  'regularRate.errors': 'regularRateError',
  'property.basicInformation.descriptions': 'descriptions',
  'searchProductsByProperty.edges': 'searchData',
  'searchProductsByProperty.total': 'searchTotal',
  'property.basicInformation.isAdultsOnly': 'isAdultsOnly',
  'property.basicInformation.resort': 'resort',
};

export const DataMap = {
  id: 'productId',
  'availabilityAttributes?.productRateCategory?.typeCode': 'new_current_category',
  'availabilityAttributes?.productRateCategory?.value': 'categoryValue',
  'availabilityAttributes?.isNearSellout': 'almostSoldOut',
  'basicInformation?.name': 'actualRoomName',
  'basicInformation?.description': 'roomDescription',
  'basicInformation?.isMembersOnly': 'membersOnlyRate',
  'basicInformation?.type': 'roomPoolCode',
  'basicInformation?.sourceOfRate': 'oldRates',
  'basicInformation?.isRepresentativeRoom': 'isRepresentativeRoom',
  'basicInformation?.isHousingProtected': 'isHousingProtected',
  'basicInformation?.actualRoomsAvailable': 'actualRoomsAvailable',
  'basicInformation?.roomsAvailable': 'roomsAvailable',
  'basicInformation?.roomsRequested': 'roomsRequested',
  'basicInformation?.depositRequired': 'depositRequired',
  'basicInformation.ratePlan[0].ratePlanType': 'ratePlanType',
  'basicInformation.ratePlan[0].ratePlanCode': 'ratePlanCode',
  'basicInformation.ratePlan[0].qualifiedRateRestriction': 'qualifiedRateRestriction',
  'totalPricing.rateModes.subtotalPerQuantity.amount': 'totalPricing',
  'totalPricing.rateModes.grandTotal.amount': 'grandTotal',
  'totalPricing.quantity': 'numOfRooms',
  'totalPricing.rateModes.totalMandatoryFeesPerQuantity.amount': 'resortFee',
  'rates.name': 'actualRateName',
  'rates.description': 'actualRateDescription',
  'rates.rateModes': 'rateModes',
  'roomAttributes.attributes': 'roomAttributes',
  roomAttributes: 'roomAttributesList',
  'rates.rateModes.averageNightlyRatePerUnit.amount.amount': 'averageNightlyRatePerUnit',
};

